module.exports = __webpack_public_path__ + "static/media/video.49e56c1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/video.svg
// module id = 166
// module chunks = 0